import { render, staticRenderFns } from "./CommissionsEdit.vue?vue&type=template&id=2065fb8f&"
import script from "./CommissionsEdit.vue?vue&type=script&lang=js&"
export * from "./CommissionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports